module.exports = __webpack_public_path__ + "static/media/GNB_02-1.9587b212.svg";